import i18n from 'i18next';

/**
 * Utility for translating text outside React components
 * Uses i18n instance directly instead of useTranslation hook
 * 
 * @param defaultText - Default text to show if translation is missing
 * @param key - Translation key (optional)
 * @param options - Additional i18n options
 * @returns Translated text or default text if translation is missing
 */
export const translate = (defaultText: string, key?: string, options?: any): string => {
  // If no key provided, return default text
  if (!key) {
    return defaultText;
  }
  
  // Try to get translation
  const translation = i18n.t(key, { ...options, defaultValue: defaultText });
  
  // If translation equals the key (not found), return default text
  if (translation === key) {
    return defaultText;
  }
  
  return translation as string;
};

/**
 * Utility for translating validation errors
 */
export const translateValidationError = (key: string, options?: any): string => {
  return translate(`${key}`, options);
};
